<template>
	<el-card :body-style="{ padding: '0' }">
		<div slot="header" class="appointment header">
			<FilterIcon class="icon"></FilterIcon>
			<span>{{ cardTitle }}</span>

			<!-- <el-button icon="el-icon-right" circle type="text" size="large"></el-button> -->
			<template v-show="!add && !edit">
				<el-dropdown @command="command">
				  <span class="el-dropdown-link">
					  Edit
				    <i class="el-icon-arrow-down el-icon--right"></i>
				  </span>
				  <el-dropdown-menu slot="dropdown" style="margin:-8px -8px 0 0">
				    <el-dropdown-item command="edit">Edit conditions</el-dropdown-item>
					<el-dropdown-item command="delete"><span class="danger">Delete filter</span></el-dropdown-item>
				  </el-dropdown-menu>
				</el-dropdown>
			</template>
		</div>

		<FilterEditor
			v-if="add"
			v-model="currentFilter"
			@change="changed"
			@save="save">
		</FilterEditor>
		<FilterEditor
			v-else-if="edit"
			v-model="filter"
			@change="changed"
			@save="update">
		</FilterEditor>
		<FilterViewer
			v-else-if="filter"
			v-bind:filter="filter"
			@edit="edit = true">
		</FilterViewer>

		<!-- <pre>{{ JSON.stringify(filter, null, 4) }}</pre> -->
	</el-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import FilterIcon from './icon/Filter'
import ListIcon from './icon/List'

import FilterEditor from './editor/Editor'
import FilterViewer from './viewer/Viewer'

export default {
	name: 'filter-card',

	props: {
		add: {
			type: Boolean
		},
		filter: {
			type: Object
		}
	},

	mounted() {
		if (this.getProvider) {
			let loadProfiles = this.getProvider.profile.filter((id) => this.getContent('profile', id) == null)
			if (loadProfiles.length > 0)
				this.loadContent({
					type: 'profile',
					id: loadProfiles
				})
		}
	},

	data() {
		return {
			edit: false,
			arg: {},
			currentFilter: {
				name: 'Untitled Filter',
				param: 'date',
				last: null,

				predicate: {
					id: ['logic', 'and'],
					term: []
				}
			}
		}
	},

	methods: {
		...mapActions('provider', [
			'createFilter',
			'editFilter',
			'removeFilter'
		]),
		...mapActions('content', [
			'loadContent'
		]),
		changed() {
			console.log('editor change', this.currentFilter)
		},
		save() {
			this.createFilter(this.currentFilter).then((filter) => {
				this.$router.push({ path: '/filter/' + filter.id })
			})
		},
		update() {
			this.editFilter(this.filter)
			this.edit = false
		},
		newRuleChange() {

		},

		command(command) {
			if (command == 'edit')
				this.edit = true
			else if (command == 'delete')
				this.$confirm('This will permanently delete the <strong>' + this.filter.name + '</strong> filter.',
					'Are you sure?', {
						confirmButtonText: 'Delete filter',
						cancelButtonText: 'Cancel',
						confirmButtonClass: 'el-button--danger',
						dangerouslyUseHTMLString: true
					})
				.then(() => {
					return this.removeFilter(this.filter)
				})
				.then(() => {
					this.$router.push({ path: '/filter' })
				})
				.catch((e) => {
					this.$router.push({ path: '/filter' })
				})
		}
	},

	computed: {
		...mapGetters('provider', [
			'getProvider'
		]),
		provider() {
			return this.getProvider
		},
		...mapGetters('content', [
			'getContent'
		]),

		cardTitle() {
			if (this.add)
				return 'Create Filter'
			else if (this.edit)
				return 'Edit Filter'
			else if (this.filter)
				return this.filter.name
			else
				return 'Filter'
		}
	},

	watch: {
		provider() {
			if (this.provider) {
				let loadProfiles = this.provider.profile.filter((id) => this.getContent('profile', id) == null)
				if (loadProfiles.length > 0)
					this.loadContent({
						type: 'profile',
						id: loadProfiles
					})
			}
		}
	},

	components: {
		FilterIcon,
		FilterEditor,
		FilterViewer
	}
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
